/**
 * Shared relay connection pool.
 *
 * Caches `NRelay1` instances by URL so WebSocket connections are reused
 * across all hooks instead of being opened fresh on every query. This keeps
 * the number of simultaneous connections low while letting every feed stream
 * from every read relay independently (results paint as each relay responds).
 */

import { NRelay1 } from '@nostrify/nostrify';

const relayCache = new Map<string, NRelay1>();

/** Get a cached `NRelay1` instance for the given URL. */
export function getRelay(url: string): NRelay1 {
  let relay = relayCache.get(url);
  if (!relay) {
    relay = new NRelay1(url);
    relayCache.set(url, relay);
  }
  return relay;
}

/** Get cached relay instances for multiple URLs. */
export function getRelays(urls: string[]): NRelay1[] {
  return urls.map(getRelay);
}
